import { MACRO_KEY } from "../../defaults";

import TooltipAndFootnotesIcon from "./icons/TooltipAndFootnotes";
import SpacerAndDividerIcon from "./icons/SpacerAndDivider";
import AnnouncementsIcon from "./icons/Announcements";
import ButtonInlineIcon from "./icons/ButtonInline";
import TextAndTitleIcon from "./icons/TextAndTitle";
import ImageSliderIcon from "./icons/ImageSlider";
import CountdownIcon from "./icons/Countdown";
import ButtonIcon from "./icons/Button";
import CardsIcon from "./icons/Cards";
import HTMLIcon from "./icons/HTML";
import PanelIcon from "./icons/Panel";
import TabsIcon from "./icons/Tabs";

import OtherModulesIcon from "./icons/OtherModules";
import OverviewIcon from "./icons/Overview";

import HelpCenter from "./help-center/icons/HelpCenter";

export const HELP_CENTER = {
  id: crypto.randomUUID(),
  label: "Help center",
  Icon: HelpCenter,
  key: "help-center",
};

const MACRO = {
  [MACRO_KEY.TEXT_AND_TITLE]: {
    id: crypto.randomUUID(),
    label: "Title and Text",
    Icon: TextAndTitleIcon,
    key: MACRO_KEY.TEXT_AND_TITLE,
  },
  [MACRO_KEY.CARDS]: {
    id: crypto.randomUUID(),
    label: "Cards",
    Icon: CardsIcon,
    key: MACRO_KEY.CARDS,
  },
  [MACRO_KEY.BUTTON]: {
    id: crypto.randomUUID(),
    label: "Button",
    Icon: ButtonIcon,
    key: MACRO_KEY.BUTTON,
  },
  [MACRO_KEY.PANEL_SIMPLE]: {
    id: crypto.randomUUID(),
    label: "Panels",
    Icon: PanelIcon,
    key: MACRO_KEY.PANEL_SIMPLE,
  },
  [MACRO_KEY.COUNTDOWN]: {
    id: crypto.randomUUID(),
    label: "Countdown",
    Icon: CountdownIcon,
    key: MACRO_KEY.COUNTDOWN,
  },
  [MACRO_KEY.ANNOUNCEMENTS]: {
    id: crypto.randomUUID(),
    label: "Announcements",
    Icon: AnnouncementsIcon,
    key: MACRO_KEY.ANNOUNCEMENTS,
  },
  [MACRO_KEY.SPACER_AND_DIVIDER]: {
    id: crypto.randomUUID(),
    label: "Divider",
    Icon: SpacerAndDividerIcon,
    key: MACRO_KEY.SPACER_AND_DIVIDER,
  },
  [MACRO_KEY.TABS]: {
    id: crypto.randomUUID(),
    label: "Tabs",
    Icon: TabsIcon,
    key: MACRO_KEY.TABS,
  },
  [MACRO_KEY.HTML]: {
    id: crypto.randomUUID(),
    label: "HTML",
    Icon: HTMLIcon,
    key: MACRO_KEY.HTML,
  },
  [MACRO_KEY.IMAGE_SLIDER]: {
    id: crypto.randomUUID(),
    label: "Image slider",
    Icon: ImageSliderIcon,
    key: MACRO_KEY.IMAGE_SLIDER,
  },
  [MACRO_KEY.PANEL_ADVANCED]: {
    id: crypto.randomUUID(),
    label: "Advanced Panels",
    Icon: PanelIcon,
    key: MACRO_KEY.PANEL_ADVANCED,
  },
  [MACRO_KEY.ADVANCED_TABS_GROUP]: {
    id: crypto.randomUUID(),
    label: "Advanced Tabs",
    Icon: TabsIcon,
    key: MACRO_KEY.ADVANCED_TABS_GROUP,
  },
  [MACRO_KEY.TOOLTIPS_AND_FOOTNOTES]: {
    id: crypto.randomUUID(),
    label: "Footnotes and Tooltips",
    Icon: TooltipAndFootnotesIcon,
    key: MACRO_KEY.TOOLTIPS_AND_FOOTNOTES,
  },
  [MACRO_KEY.BUTTON_INLINE]: {
    id: crypto.randomUUID(),
    label: "Button Inline",
    Icon: ButtonInlineIcon,
    key: MACRO_KEY.BUTTON_INLINE,
  },
  [MACRO_KEY.FOOTNOTE_DISPLAY]: {
    id: crypto.randomUUID(),
    label: "Footnote display",
    Icon: TooltipAndFootnotesIcon,
    key: MACRO_KEY.FOOTNOTE_DISPLAY,
  },
  [MACRO_KEY.ADVANCED_TABS_SINGLE]: {
    id: crypto.randomUUID(),
    label: "Advanced Tabs",
    Icon: ButtonInlineIcon,
    key: MACRO_KEY.ADVANCED_TABS_SINGLE,
  },

  [MACRO_KEY.OVERVIEW_KEY]: {
    id: crypto.randomUUID(),
    label: "Overview",
    Icon: OverviewIcon,
    key: MACRO_KEY.OVERVIEW_KEY,
  },
  [MACRO_KEY.OTHER_MODULES_KEY]: {
    id: crypto.randomUUID(),
    label: "Other modules",
    Icon: OtherModulesIcon,
    key: MACRO_KEY.OTHER_MODULES_KEY,
  },
};

export const EDITOR_MACROS = [
  MACRO[MACRO_KEY.OVERVIEW_KEY],
  MACRO[MACRO_KEY.CARDS],
  MACRO[MACRO_KEY.PANEL_SIMPLE],
  MACRO[MACRO_KEY.BUTTON],
  MACRO[MACRO_KEY.ANNOUNCEMENTS],
  MACRO[MACRO_KEY.COUNTDOWN],
  MACRO[MACRO_KEY.IMAGE_SLIDER],
  MACRO[MACRO_KEY.TEXT_AND_TITLE],
  MACRO[MACRO_KEY.SPACER_AND_DIVIDER],
  MACRO[MACRO_KEY.HTML],
  MACRO[MACRO_KEY.OTHER_MODULES_KEY],
];

export const MACROS_WITHOUT_SIDEBAR = [
  MACRO[MACRO_KEY.ADVANCED_TABS_GROUP],
  MACRO[MACRO_KEY.ADVANCED_TABS_SINGLE],
  MACRO[MACRO_KEY.PANEL_ADVANCED],
  MACRO[MACRO_KEY.TOOLTIPS_AND_FOOTNOTES],
  MACRO[MACRO_KEY.FOOTNOTE_DISPLAY],
  MACRO[MACRO_KEY.BUTTON_INLINE],
];

export const MACROS_WITHOUT_SETTINGS = [
  MACRO[MACRO_KEY.HTML],
  MACRO[MACRO_KEY.OVERVIEW_KEY],
  MACRO[MACRO_KEY.OTHER_MODULES_KEY],
];
